import { render, staticRenderFns } from "./EmployeeNewUser.vue?vue&type=template&id=10ea3880&"
import script from "./EmployeeNewUser.vue?vue&type=script&lang=js&"
export * from "./EmployeeNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports